<div class="row">
	<div class="col-6 position-relative" style="height: 280px;">
		<ngb-datepicker #datePicker1 (dateSelect)="onDateSelection($event)" [displayMonths]="1" [dayTemplate]="t" outsideDays="hidden" [maxDate]="toDate!" [startDate]="fromDate!" (navigate)="onFromNavigateEvent($event)" class="position-absolute top-50 start-50 translate-middle">
		</ngb-datepicker>
	</div>
	<div class="col-6 position-relative" style="height: 280px;">
		<ngb-datepicker #datePicker2 (dateSelect)="onDateSelection($event)" [displayMonths]="1" [dayTemplate]="t" outsideDays="hidden" [maxDate]="calendar.getToday()" [startDate]="toDate!" (navigate)="onToNavigateEvent($event)" class="position-absolute top-50 start-50 translate-middle">
		</ngb-datepicker>
	</div>
</div>
<div class="row">
	<div class="col-6">
		<div class="input-group">
			<input #dpFromDate class="form-control text-center" placeholder="mm/dd/yyyy" name="dpFromDate" [value]="formatter.format(fromDate)" (input)="fromDate = validateInput(fromDate, dpFromDate.value, minDateChange)" />
		</div>
	</div>
	<div class="col-6">
		<div class="input-group">
			<input #dpToDate class="form-control text-center" placeholder="mm/dd/yyyy" name="dpToDate" [value]="formatter.format(toDate)" (input)="toDate = validateInput(toDate, dpToDate.value, maxDateChange)" />
		</div>
	</div>
</div>

<ng-template #t let-date let-focused="focused">
	<span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
		{{ date.day }}
	</span>
</ng-template>